import { Chart as ChartJS, ChartOptions } from "chart.js";

ChartJS.defaults.font.size = 12;

export function getChartDefaults(hasData: boolean): ChartOptions {
    return {
        responsive: true,
        maintainAspectRatio: true,
        elements: {
            bar: {
                borderWidth: 1,
            }
        },
        plugins: {
            legend: {
                position: 'bottom',
                align: "center",
                display: true,
            },
            title: {
                display: true,
                padding: 20,
                align: "start"
            },
            tooltip: {
                borderWidth: 1,
                padding: 10,
                caretPadding: 15,
                boxPadding: 5,
                displayColors: false
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                min: 0,
                max: hasData ? undefined : 10,
                ticks: {
                    stepSize: hasData ? undefined : 1,
                    display: hasData,
                },
                grid: {
                    drawTicks: true, // Keep grid lines
                }
            },
        }
    }
}